<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  name: 'AuditWidget',
  data() {
    return {
      auditData: [
        {
          name: 'Gering',
          data: [['offene Aufgaben', 0]],
        },
        {
          name: 'Normal',
          data: [['offene Aufgaben', 0]],
        },
        {
          name: 'Hoch',
          data: [['offene Aufgaben', 0]],
        },
      ],
    };
  },
  computed: {
    ...mapGetters('taskList', ['list']),
  },
  watch: {
    list: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    refreshAuditData() {
      this.auditData = this.auditData.slice();
    },
    fetchTaskData() {
      return axios.get('/task')
        .then((response) => {
          const tasks = response.data
            .filter(it => !it.isDelete
              && typeof it.status !== 'undefined'
              && it.status !== 2
              && it.priority !== 3);

          let taskLowCount = 0;
          let taskNormalCount = 0;
          let taskHighCount = 0;

          tasks.forEach((task) => {
            if (task.priority === 0) {
              taskLowCount += 1;
            } else if (task.priority === 1) {
              taskNormalCount += 1;
            } else if (task.priority === 2) {
              taskHighCount += 1;
            }
          });

          this.auditData[0].data[0][1] = taskLowCount;
          this.auditData[1].data[0][1] = taskNormalCount;
          this.auditData[2].data[0][1] = taskHighCount;
        });
    },
    fetchData() {
      axios.all([
        this.fetchTaskData(),
      ])
        .then(axios.spread(() => {
          this.auditData = this.auditData.slice();
        }));
    },
    openAudits() {
      this.$router.push('/privacyAudits');
    },
  },
};
</script>

<template>
  <div>
    <v-card>
      <v-card-title class="assignment-title"
                    @click="openAudits">
        <v-icon
          large
          left
        >
          assignment
        </v-icon>
        <span class="title"> Audit </span>
      </v-card-title>
      <bar-chart :stacked="true" :data="auditData" :colors="['#CFD8DC','#FB8C00','#D32F2F']" />
    </v-card>
  </div>
</template>

<style lang="scss" scoped>
.assignment-title {
  cursor: pointer;
}
</style>
